import { render, staticRenderFns } from "./Trivia14.vue?vue&type=template&id=9e0c7cd6&"
import script from "./Trivia14.vue?vue&type=script&lang=js&"
export * from "./Trivia14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports